import PaymentList from './PaymentList';

export default PaymentList;
